import React from 'react';
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import EventImage from '../../../../components/EventImage';
import StatusBadge from '../../../../components/StatusBadge';
import './EventApprovalTable.css';

const EventApprovalTable = ({ events, onViewEvent, currentPage, itemsPerPage }) => {
  if (!events || events.length === 0) return null;

  const paginatedEvents = events.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="modern-events-list">
      <div className="events-table-header">
        <div className="event-col event-col-img">Image</div>
        <div className="event-col event-col-name">Event Name</div>
        <div className="event-col event-col-date">Date</div>
        <div className="event-col event-col-location">Location</div>
        <div className="event-col event-col-type">Type</div>
        <div className="event-col event-col-status">Status</div>
        <div className="event-col event-col-action">Action</div>
      </div>
      <div className="events-table-body">
        {paginatedEvents.map((event) => (
          <div className="event-row" key={event.eventid}>
            <div className="event-col event-col-img">
              <div className="event-image-container">
                <EventImage
                  image={event.file_url}
                  coverimage={event.file_url}
                  alt={event.event_name}
                  loading="eager"
                />
              </div>
            </div>

            <div className="event-col event-col-name">
              <div className="event-name">{event.event_name}</div>
              <div className="event-time">
                <FaClock className="event-icon" />
                <span>{event.time}</span>
              </div>
            </div>

            <div className="event-col event-col-date">
              <div className="event-date">
                <FaCalendarAlt className="event-icon" />
                <span>{event.formattedDate}</span>
              </div>
            </div>

            <div className="event-col event-col-location">
              <div className="event-location">
                <FaMapMarkerAlt className="event-icon" />
                <span>{event.location}</span>
              </div>
            </div>

            <div className="event-col event-col-type">
              <div className="event-type">{event.event_type}</div>
            </div>

            <div className="event-col event-col-status">
              {event.status && (
                <StatusBadge status={event.status} />
              )}
            </div>

            <div className="event-col event-col-action">
              <button
                type="button"
                className="view-event-btn"
                onClick={() => onViewEvent && onViewEvent(event)}
              >
                View
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventApprovalTable;
